import { createContext, useContext, useState } from "react";
import { currentSeason, SEASON_ORDER } from "@/lib/services";

const SeasonContext = createContext(null);

export function SeasonProvider({ children }) {
  const [season, setSeason] = useState(currentSeason());
  const cycleSeason = () =>
    setSeason((s) => SEASON_ORDER[(SEASON_ORDER.indexOf(s) + 1) % SEASON_ORDER.length]);
  return (
    <SeasonContext.Provider value={{ season, cycleSeason }}>{children}</SeasonContext.Provider>
  );
}

export const useSeason = () => useContext(SeasonContext);
